import { render, staticRenderFns } from "./AddAppointmentTypeForm.vue?vue&type=template&id=61416d95"
import script from "./AddAppointmentTypeForm.vue?vue&type=script&lang=ts"
export * from "./AddAppointmentTypeForm.vue?vue&type=script&lang=ts"
import style0 from "./AddAppointmentTypeForm.vue?vue&type=style&index=0&id=61416d95&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports